/* global THREE */
import aframe from "aframe";
import { stringifyRotation } from "@micosmo/aframe/lib/utils";

aframe.registerComponent("copy-transform", {
  schema: {
    element: { type: "selector" },
    threeObjectName: { type: "string" }
  },
  init() {
    this._findThreeObjectAndCopyTransform = this._findThreeObjectAndCopyTransform.bind(this);
    this.dirty = false;
  },
  update: function(oldData) {
    if (this.data.threeObjectName) {
      if (oldData.element) {
        oldData.element.removeEventListener("model-loaded", this._findThreeObjectAndCopyTransform);
      }
      this.data.element.addEventListener("model-loaded", this._findThreeObjectAndCopyTransform);
    }
    this.dirty = true;
  },
  remove() {
    this.data.element.removeEventListener("model-loaded", this._findThreeObjectAndCopyTransform);
  },
  tick(t, dt) {
    if (this.dirty) {
    //  console.log('copy-transform tick', this.data.threeObjectName, this.data.element);
      if (this.data.threeObjectName)
        this._findThreeObjectAndCopyTransform();
      else
        this._copyTransformOfObject3D(this.data.element.object3D);
      this.dirty = false;
    }
  },
  _copyTransformOfObject3D: (() => {
    const m1 = new THREE.Matrix4();
    const v1 = new THREE.Vector3();
    return function(target) {
    //  console.log('_copyTransformOfObject3D');
      this.el.sceneEl.object3D.updateMatrixWorld();
      const targetTransform = m1
        .copy(this.el.parentEl.object3D.matrixWorld)
        .invert()
        .multiply(target.matrixWorld);

      this.el.setAttribute(
        "position",
        v1.setFromMatrixPosition(targetTransform)
      );
      this.el.setAttribute("rotation", stringifyRotation(targetTransform));
      this.el.emit("actorready");
    };
  })(),
  _findThreeObjectAndCopyTransform() {
  //  console.log('_findThreeObjectAndCopyTransform', this.data.threeObjectName, this.data.element);
    const threeObject = findObjectByName(
      this.data.element.object3D,
      this.data.threeObjectName
    );
    // console.log('_findThreeObjectAndCopyTransform', threeObject);
    if (threeObject) {
      this._copyTransformOfObject3D(threeObject);
    }
  }
});

const findObjectByName = (root, name) => {
  // Skip this if there is nothing to do.
  if (root.children.length === 0)
    return undefined;

  let found;
  root.traverse(x => {
    if (x.name === name) {
      found = x;
    }
  });
  if (!found)
    console.error('copy-transform:findObjectByName - Missing object3D.', root.el.id, name);
  return found;
};
